module.exports = __webpack_public_path__ + "static/media/file-export.541f410e.svg";